<div class="container-fluid">
    <app-report reportId="alarmsDashboard" screen="AMICAALARMS"></app-report>
</div>
